import { useMediaQuery } from "@mui/material";
import MainMenu from "./MainMenu.js";
import MobileMenu from "./MobileMenu.js";

const ResponsiveMenu = () => {
  const isMobile = useMediaQuery("(max-width:844px)");
  return isMobile ? <MobileMenu /> : <MainMenu />;
};

export default ResponsiveMenu;
